import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export function RequireAuth() {
  const { access, errorMessage, signOut } = useAuth();

  if (access === 'loading') {
    return <div className="center-screen"><div className="spinner" /></div>;
  }
  if (access === 'signed_out') {
    return <Navigate to="/login" replace />;
  }
  if (access === 'not_allowlisted') {
    return (
      <div className="center-screen">
        <div className="card narrow">
          <h2>Access pending</h2>
          <p>Your Google account isn't on the developer allowlist yet. Ask an admin to add your email.</p>
          <button className="btn" onClick={() => void signOut()}>Sign out</button>
        </div>
      </div>
    );
  }
  if (access === 'error') {
    return (
      <div className="center-screen">
        <div className="card narrow">
          <h2>Something went wrong</h2>
          <p className="muted">{errorMessage ?? 'Failed to load your developer profile.'}</p>
          <button className="btn" onClick={() => void signOut()}>Sign out</button>
        </div>
      </div>
    );
  }
  return <Outlet />;
}
